var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsFacebook = function SvgPbsFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Facebook",
    className: "pbs-facebook_svg__pbs-facebook",
    viewBox: "0 0 80 171"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M53.036 55.806V41.072q-.001-3.319.31-5.135.31-1.818 1.402-3.582 1.088-1.763 3.527-2.437 2.44-.676 6.488-.675h14.733V-.225H55.942q-20.444 0-29.366 9.7-8.923 9.704-8.923 28.587v17.744H.012v29.469h17.64v85.5h35.384v-85.5h23.553l3.113-29.47z"
  })));
};
export default SvgPbsFacebook;